
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 700 700"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M208 353.7c6.9 1.1 13.1-4.6 13.1-11.4v-86.9c0-9.7 7.4-17.1 17.1-17.1h223.4l-50.3 50.3c-4.6 4-4.6 10.9-.6 15.4l.6.6c4 4.6 10.9 4.6 15.4.6l.6-.6 64.6-64c4-4 5.7-8.6 5.7-14.3 0-5.1-2.3-10.3-5.7-14.3l-64.6-63.4c-5.1-4-12-2.9-16 2.3-2.9 4-2.9 9.7 0 13.7l50.3 50.9H238.3c-22.3 0-40 17.7-40 40v86.3c0 5.7 4 10.8 9.7 11.9zM488 338.9c-5.7 1.1-9.7 6.3-9.7 12v92c0 9.7-7.4 17.1-17.1 17.1H237.8l50.3-50.3c4-5.1 2.9-12-2.3-16-4-2.9-9.7-2.9-13.7 0l-64 64c-4 4-5.7 9.1-5.7 14.3 0 4.6 2.3 9.7 5.7 13.1l64.6 65.1c4 4.6 10.9 4.6 15.4.6l.6-.6c4.6-4 4.6-10.9.6-15.4l-.6-.6-50.3-50.9h223.4c22.3 0 40-17.7 40-40v-93.1c-.7-6.8-6.9-12.5-13.8-11.3z"}})])
          )
        }
      }
    